export function useAnalytics() {
  return {
    track: () => {}
  }
}
